export default __webpack_public_path__ + "static/media/install-gremlin.f6695a7b6d04733ea0f492f63e336cc1.svg";